import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'

const chatSearchSchema = z.object({
  prompt: z.string().optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/',
)({
  validateSearch: chatSearchSchema,
})
